// contactUs.jsx
import ContactInfoSection from "./ContactInfoSection";
import ContactFormSection from "./ContactFormSection";
import FadeInOnScroll from "./FadeInOnScroll";      // ✅ 新增
import SlideInOnScroll from "./SlideInOnScroll";    // ✅ 新增

export default function ContactUs() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44] min-h-screen">
      {/* 背景装饰光晕 */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute w-[28rem] h-[28rem] bg-purple-300/25 rounded-full blur-3xl top-[-6rem] -left-16 animate-pulse" />
        <div className="absolute w-[30rem] h-[30rem] bg-indigo-300/25 rounded-full blur-3xl bottom-[-8rem] right-[-4rem] animate-pulse" />
        <div className="absolute w-[18rem] h-[18rem] bg-fuchsia-300/20 rounded-full blur-3xl top-1/3 right-10" />
      </div>

      {/* Hero 区域 */}
      <div className="relative max-w-5xl mx-auto pt-24 pb-16 px-6 text-center">
        <FadeInOnScroll>
          <h1 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-[#6a2dd9] via-[#9a8dfc] to-[#b794ff] bg-clip-text text-transparent">
            Contact Us
          </h1>
          <p className="text-[#5e4ca8] font-medium text-lg mt-4 tracking-wide">
            We would love to hear from you.
          </p>
          <div className="mx-auto mt-6 w-24 h-1 bg-gradient-to-r from-[#a076f9] to-[#7b5cff] rounded-full" />
          <p className="mt-4 text-[#2a0f4c]/80 max-w-2xl mx-auto">
            Whether you have a question about services, partnership, or anything
            else, <br />our team is ready to answer your questions.
          </p>
        </FadeInOnScroll>
      </div>

      {/* 主内容卡片 */}
      <div className="relative mx-auto pb-20">
        <div>
          <div className="grid grid-cols-1">
            {/* 上：联系方式 —— 从左滑入 */}
            <SlideInOnScroll from="left">
              <ContactInfoSection />
            </SlideInOnScroll>

            {/* 下：表单 —— 从右滑入 */}
            <SlideInOnScroll from="right" delay={0.1}>
              <ContactFormSection />
            </SlideInOnScroll>
          </div>
        </div>
      </div>
    </section>
  );
}
